import {
  DownOutlined,
  KeyOutlined,
  LogoutOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Button, Dropdown, Layout, Menu } from 'antd';
import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import UserApi from '../../functions/api/user/UserApi';
import Notification from './Notification';

class HeaderLinks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLogout: !reactLocalStorage.getObject('user.info'),
    };
  }

  handleLogout = async () => {
    await UserApi.logout();
    this.setState({ isLogout: true });
  };

  render() {
    if (this.state.isLogout) {
      return <Redirect push to="/login" />;
    }

    const menu = (
      <Menu>
        <Menu.Item key="change_password" icon={<KeyOutlined />}>
          <Link to="/change-password">Đổi mật khẩu</Link>
        </Menu.Item>
        <Menu.Item
          key="logout"
          icon={<LogoutOutlined />}
          onClick={() => this.handleLogout()}
        >
          Log Out
        </Menu.Item>
      </Menu>
    );

    const userInfo = reactLocalStorage.getObject('user.info');

    return (
      <Layout.Header className="top-bar">
        <Notification />
        <Dropdown overlay={menu}>
          <Button>
            <UserOutlined />
            {userInfo.user_acc_full_name}
            <DownOutlined />
          </Button>
        </Dropdown>
      </Layout.Header>
    );
  }
}

export default HeaderLinks;
